import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import PartialNavLink from '../partial-nav-link/PartialNavLink.jsx'
import ViewerMode from './ViewerMode.jsx'
import Tooltip from '../tooltip/Tooltip.jsx'
import classnames from 'classnames'
const renderLinks = menu => {
  const allLinks = menu.map(x => {
    if (x.link === '/') {
      return (
        <Link key={x.link} activeClassName="current" to={x.link}>
          {x.text}
        </Link>
      )
    } else {
      return (
        <PartialNavLink key={x.link} activeClassName="current" to={x.link}>
          {x.text}
        </PartialNavLink>
      )
    }
  })
  return allLinks
}
const mastheadClass = transparent => {
  return classnames('masthead', {
    'masthead--transparent': transparent,
  })
}
const renderNewDocIcon = () => {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="currentColor" fill="none">
        <path fill="#F4F2EE" d="M16 20.371V6.613L10.525.8H1v19.571z" />
        <path strokeLinejoin="round" d="M10 1v6h6" />
        <g strokeLinecap="round" strokeLinejoin="round">
          <path d="M4.323 17.59l7.905-7.634M8 9.882l4.228.074-.074 4.228" />
        </g>
      </g>
    </svg>
  )
}

const renderPrefix = process.env.GATSBY_SITE_URL
  ? '/' + process.env.GATSBY_SITE_URL
  : ''

const Masthead = props => (
  <StaticQuery
    query={graphql`
      query {
        mastheadJson {
          exhibitLink
          menu {
            text
            link
          }
          exhibitMenu {
            text
            link
          }
        }
      }
    `}
    render={data => (
      <div className={mastheadClass(props.transparent)}>
        <div className="masthead__headings">
          {props.showModeViewer && (
            <ViewerMode
              toggledSetting={props.toggledSetting}
              updateToggledSetting={props.updateToggledSetting}
            />
          )}
          {props.showCatalog && (
            <Tooltip
              tooltipText={
                props.showCatalogMenu
                  ? 'View Exhibition Catalogue'
                  : 'Open in New Tab'
              }
            >
              <div className="catalogue">
                <a
                  className={props.current === 'catalog' ? 'current' : ''}
                  href={renderPrefix + data.mastheadJson.exhibitLink}
                  target={props.showCatalogMenu ? '_self' : '_blank'}
                >
                  <span className="catalogue__text">Exhibition Catalogue</span>
                  {renderNewDocIcon()}
                  <span className="catalogue__title">
                    Ausstellung Pablo Picasso (1913)
                  </span>
                </a>
              </div>
            </Tooltip>
          )}
        </div>
        <nav className="masthead__nav">
          {props.showCatalog}
          {props.showCatalogMenu
            ? renderLinks(data.mastheadJson.exhibitMenu)
            : renderLinks(data.mastheadJson.menu)}
        </nav>
      </div>
    )}
  />
)
export default Masthead
